import { createStore } from 'vuex'
import {Usuario} from "@/models/user.interface";
import {UserService} from "@/services/user.service";

export default createStore({
  state: {
    current_user:{token:"",name:"",lastname:"",profiles:[]} as Usuario,
  },
  getters: {
    getCurrentUser(state){
      return state.current_user;
    }
  },
  mutations: {
    setCurrentUser(state,payload:Usuario){

      state.current_user = payload;
    }
  },
  actions: {
      set_current_user({commit,state},usuario:Usuario){
      commit('setCurrentUser',usuario);
    }
  },
  modules: {
  }
})
